const AUTH_DATA = "@ctruck-Auth-Data";

function isAuthenticated() {
    var sensiveAuthData = getSensiveAuthData();
    return sensiveAuthData && (sensiveAuthData.exp*1000) >= Date.now();
}

function getSensiveAuthData(){
    var authData = getAuthData();
    if(authData && authData.token !== null){
        const jwt = require('jsonwebtoken');
        try {
            var sensiveData = jwt.verify(getAuthData().token || '', process.env.REACT_APP_JWT_KEY);
        } catch(e){ return false; }
    }
    return sensiveData;
}

function getAuthData(){
    var authData = localStorage.getItem(AUTH_DATA);
    if(authData && authData !== '') {
        try {
            return JSON.parse(authData);
        } catch(error){
            return false;
        }
    }
    return false;
}

function setAuthData(data){
    removeAuthData();
    if(typeof data === 'object') data = JSON.stringify(data);
    localStorage.setItem(AUTH_DATA, data);
}

function removeAuthData(){
    localStorage.removeItem(AUTH_DATA);
}

function isAdmin(){
    var sensiveAuthData = getSensiveAuthData();
    return sensiveAuthData && sensiveAuthData.isadmin 
        && sensiveAuthData.isadmin === 1;
}

export {
    isAuthenticated,
    getAuthData,
    setAuthData,
    removeAuthData,
    isAdmin
}